var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-0 pa-0"},[(_vm.activateLayout)?_c('share-page-edit',{attrs:{"grids":_vm.sharepageItems[0].grids.value,"sharePageFiles":_vm.sharePageFiles,"pageTitle":_vm.sharepageItems[0].pagetitle}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }